import { AddOutlined } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { Can } from "src/shared/lib/rback/Can";
import { ITableHeaderProps } from "../model/types/types";

export const TableHeader = ({ onAddClick }: ITableHeaderProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Typography variant="h6">Справочник стран для таргетинга</Typography>
      <Can perform="system.targeting.edit">
        <Button
          variant="contained"
          startIcon={<AddOutlined />}
          onClick={onAddClick}
        >
          Добавить страну
        </Button>
      </Can>
    </Box>
  );
};
